import CnpjUtils from "../../shared/utils/CnpjUtils";

/**
 * Função para cadastrar cliente no Essilor Promo (iPremios)
 * 
 * API Documentation: https://portal-api.essilor.com.br/api-portal/swagger/ipremios-cadastro/1.0#/cliente/post_clientes
 * 
 * Endpoint: POST /clientes
 * URLs base:
 * - Desenvolvimento: https://api.essilor.com.br/dev/ipremios-cadastro/v1/clientes
 * - Homologação: https://api.essilor.com.br/hml/ipremios-cadastro/v1/clientes
 * - Produção: https://api.essilor.com.br/ipremios-cadastro/v1/clientes
 * 
 * Headers obrigatórios:
 * - client_id (required) - Client_Id para OAuth
 * - access_token (required) - Access Token para OAuth
 */
async function post_cadastro_essilor_promo(dados) {
  const tipoInformado = dados.conta.tipoDeParticipante || "OTICA";
  const tipoParticipante = ["OTICA_PRODUTORA", "OTICA PRODUTORA"].includes(tipoInformado) ? "OTICA" : tipoInformado;

  // Payload conforme especificação da API iPremios
  const payload = {
    tipo_participante: tipoParticipante,
    cnpj: CnpjUtils.cleanCnpj(dados.conta.cnpj),
    razao_social: dados.conta.razaoSocial,
    nome_fantasia: dados.conta.nomeFantasia,
    email: dados.conta.email,
    endereco: dados.conta.logradouro,
    cep: dados.conta.cep?.replace(/\D/g, ""),
    logradouro: dados.conta.logradouro,
    numero_endereco: dados.conta.numero,
    complemento_endereco: dados.conta.complemento || "",
    bairro: dados.conta.bairro,
    ponto_referencia_endereco: dados.conta.pontoDeReferencia || "",
    municipio: dados.conta.cidade,
    uf: dados.conta.estado,
    ddd_telefone_celular: dados.conta.DDDCelular?.replace(/\D/g, ""),
    telefone_celular: dados.conta.celular?.replace(/\D/g, ""),
    ddd_telefone_trabalho: dados.conta.DDDTelefone?.replace(/\D/g, ""),
    telefone_trabalho: dados.conta.telefoneDeTrabalho?.replace(/\D/g, ""),
  };

  // Obter o access_token do localStorage
  // Nota: sessionStorage.getItem("token") contém o access_token do Sensidia
  const accessToken = sessionStorage.getItem("token");
  
  if (!accessToken || accessToken === "undefined" || accessToken === "null") {
    console.error("Access token não encontrado ou inválido no localStorage");
    return {
      success: false,
      status: 401,
      message: "Token de acesso não encontrado. Por favor, faça login novamente.",
      error: "Access token missing"
    };
  }

  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      ...payload,
      access_token: accessToken,
    }),
  };

  try {
    const response = await fetch(
      process.env.REACT_APP_LABS_API + "sensidia/ipremios/post_cadastro_cliente_essilor_promo.php",
      requestOptions
    );
    const json = await response.json();
    
    // Se for erro 401, pode ser token expirado
    if (json.status === 401) {
      console.warn("Token de acesso expirado ou inválido. Erro 401 do Essilor Promo.");
    }
    
    return json;
  } catch (error) {
    console.error("Erro ao cadastrar cliente no Essilor Promo:", error);
    return {
      success: false,
      status: 500,
      message: "Erro ao tentar cadastrar no Essilor Promo: " + error.message,
      error: error.message
    };
  }
}

export { post_cadastro_essilor_promo };
